import { getParsedCardValidityValues } from '@src/common';

export type CardValidityParts = {
  validityMonth: string;
  validityYear: string;
};

// An absent validity yields empty parts rather than a parse of NaN: the legacy checkout submits the
// pix form through the same handler, so it reaches this with no card validity at all.
export const parseCardValidityParts = (validity: string | undefined): CardValidityParts => {
  if (!validity) {
    return { validityMonth: '', validityYear: '' };
  }

  return getParsedCardValidityValues(validity);
};
